import DefaultProgressiveProfile from './DefaultProgressiveProfile';

export default class ReferToDiscoProgressiveProfile extends DefaultProgressiveProfile {
  public override onClient(): void {
    super.onClient();
    try {
      const loc = new URL(document.location.href);
      const refCode = loc.searchParams.get('referralCode');
      if (refCode) {
        const newLoc = new URL(document.location.href);
        newLoc.searchParams.delete('referralCode');
        newLoc.searchParams.set('refCode', refCode);
        newLoc.searchParams.set('v2', 'true');
        document.location.href = newLoc.href;
      }
    } catch (e) {
      console.error('Error processing referral code:', e);
    }
  }
}
